import React, { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 1.25rem;
`;

const Title = styled.h1`
  font-size: 1.125rem;
  font-weight: 500;
  color: var(--gray-900);
  margin-bottom: 0.25rem;
`;

const Subtitle = styled.p`
  font-size: 0.9rem;
  font-weight: 400;
  max-width: 60rem;
  color: var(--gray-500);
`;

type Props = {
  title: string;
  subtitle: string | string[];
};
const Head: FC<Props> = ({ title, subtitle }) => {
  return (
    <Container>
      <Title>{title}</Title>

      <Subtitle>
        {typeof subtitle === 'string'
          ? subtitle
          : subtitle.map((sub, idx) => (
              <React.Fragment key={idx}>
                {sub}
                <br />
              </React.Fragment>
            ))}
      </Subtitle>
    </Container>
  );
};

export default Head;
